import React from "react";

export default function Checkbox({ id, type = "checkbox", name, checked = false, onChange, label = '', value = '', ariaLabel = '', customRadioStyle = false }) {
    const amazonUrl = process.env.REACT_APP_SAFRA_BANNER_LINKS;

    return (
        <div className={`d-flex ${type === 'radio' ? 'align-items-center' : ''}  `}>
            {type === 'radio' && customRadioStyle ? (
                <label className="custom-ll-radio" htmlFor={id} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <input
                        id={id}
                        type="radio"
                        name={name}
                        checked={checked}
                        onChange={onChange}
                        value={value}
                        aria-label={ariaLabel || label}
                        style={{ display: 'none' }}
                    />
                    <img className="unchecked" src={`${amazonUrl}/public/safra/img/unchecked.png`} alt="Não selecionado" style={{ display: checked ? 'none' : 'block' }} />
                    <img className="checked" src={`${amazonUrl}/public/safra/img/checked.png`} alt="Selecionado" style={{ display: checked ? 'block' : 'none' }} />
                    {label && <span className="ms-2 pt-1">{label}</span>}
                </label>
            ) : (
                <>
                    <input id={id} type={type} name={name} checked={checked} onChange={onChange} value={value}
                           className={`${type === 'checkbox' && 'form-check-input'}`}
                           aria-label={ariaLabel || label}
                           aria-checked={type === 'checkbox' ? checked : undefined}/>
                    {label &&
                        <label htmlFor={id} className="ms-2">
                            {label}
                        </label>
                    }
                </>
            )}
        </div>
    )
}
